import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import Styled from 'styled-components';
import {Button} from '@forecast-it/design-system';

// Shown when a scheduling data load fails for any reason. The retry re-runs the
// view's own fetch in place — it must not reload the page or navigate.
export const SchedulingLoadError = ({onRetry}) => {
	const {formatMessage} = useIntl();

	return (
		<SchedulingLoadErrorStyled data-cy="scheduling-load-error">
			<span>
				<FormattedMessage id="scheduling.load_error" />
			</span>
			<Button emphasis={'high'} icon={'reload'} onPress={onRetry}>
				{formatMessage({id: 'scheduling.load_error.retry'})}
			</Button>
		</SchedulingLoadErrorStyled>
	);
};

const SchedulingLoadErrorStyled = Styled.div`
    height: 100%;
    width: 100%;
    display: grid;
    align-content: center;
    justify-items: center;
    gap: 16px;
`;
